<template>
    <v-sheet>
        <h5 class="page-text--lg font-weight-medium">{{ title }}</h5>
        <v-btn v-for="{ text, value, isActive } in items" :key="value" @click="toggle(value)" block outlined :color="isActive ? 'primary' : 'grey-9'" :class="isActive ? '' : 'grey-6--text'" :elevation="isActive ? 1 : undefined" class="mt-10">
            <v-row no-gutters align="center">
                <v-col cols="auto">
                    <v-simple-checkbox :value="isActive" color="primary" @click="toggle(value)" />
                </v-col>
                <v-col class="text-start">{{ text }}</v-col>
            </v-row>
        </v-btn>
    </v-sheet>
</template>

<script>
import dayjs from "dayjs";

export default {
    props: {
        value: { type: [Array, String], default: () => [] },

        date: { type: [String, Date], default: Date.now().toDate() },
        multiple: { type: Boolean, default: false },

        timeStarts: { type: String, default: "9:00" },
        timeEnds: { type: String, default: "21:00" },
        timeSpan: { type: String, default: "0:30" },
    },
    data: () => ({
        selected: [],
    }),
    computed: {
        title() {
            return dayjs(this.date).format("YYYY년 M월 D일 시간선택");
        },
        startTime() {
            let [hour, minute] = this.timeStarts.split(":");
            return dayjs(this.date).set("hour", hour).set("minute", minute).startOf("minute").toISOString();
        },
        endTime() {
            let [hour, minute] = this.timeEnds.split(":");
            return dayjs(this.date).set("hour", hour).set("minute", minute).startOf("minute").toISOString();
        },
        items() {
            let times = [];
            let [spanHours, spanMinutes] = this.timeSpan.split(":");
            do {
                let lastTime = [...times].pop() || dayjs(this.startTime).subtract(spanHours, "hours").subtract(spanMinutes, "minutes").toISOString();
                let nextTime = dayjs(lastTime).add(spanHours, "hours").add(spanMinutes, "minutes").toISOString();
                times.push(nextTime);
            } while (dayjs([...times].pop()).isBefore(this.endTime));

            return times.map((value) => ({
                value,
                text: dayjs(value).format("a hh:mm").replace("am", "오전").replace("pm", "오후"),
                isActive: this.value.includes(value),
            }));
        },
    },
    methods: {
        toggle(value) {
            let items = [...this.value];
            if (!items.includes(value)) items = [...items, value];
            else items = items.filter((item) => item != value);
            this.$emit("input", items);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default {
        font-weight: 400;
        font-size: 1.4rem;
        padding: 0 16px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    ::v-deep {
        .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--text).v-size--default {
            font-size: 1.8rem;
            padding: 0 16px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>
